import { FormattedMessage } from 'react-intl';

import { Lineup } from '@sorare/core/src/atoms/icons/Lineup';
import { BrandXXS } from '@sorare/core/src/atoms/typography/index.tsx';

export const PrepareLineupTooltipContent = () => (
  <div className="flex items-center gap-1">
    <Lineup size={2} color="var(--c-onBase-secondary)" />
    <BrandXXS color="var(--c-onBase-secondary)" className="text-nowrap">
      <FormattedMessage defaultMessage="Pre-set lineups" />
    </BrandXXS>
  </div>
);
